import gql from 'graphql-tag';

export const UPSERT_PIN_SET = gql`
  mutation UpsertPinSet($input: PinSetInput!) {
    upsertPinSet(input: $input) {
      pinSetId
    }
  }
`;
